module.exports = __webpack_public_path__ + "img/coat_of_arms.f35eb40c.jpg";